import React from 'react';
import { Message, User } from '../types.ts';
import MessageList from './MessageList.tsx';
import MessageInput from './MessageInput.tsx';

type Props = {
    self: User | null;
    activeChatEmail: string | null;
    messages: Message[];
};

const ChatWindow: React.FC<Props> = ({ self, activeChatEmail, messages }) => {
    if (!self) return <div className="chat-window">Loading...</div>;

    return (
        <div className="chat-window">
            <MessageList messages={messages} />
            <MessageInput self={self} toEmail={activeChatEmail} />
        </div>
    );
};

export default ChatWindow;
